import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

import { Glyphicon } from "../Glyphicon/Glyphicon";

import { _CloseButton as CloseButton, _Icon as Icon } from "./style";

export const Tooltip = ({ content, dataId }) => {
  const [modalIsOpen, isModalIsOpen] = React.useState(false);

  return (
    <>
      <Icon data-id={dataId} onClick={() => isModalIsOpen(true)}>
        <Glyphicon name="circle-info" />
      </Icon>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => isModalIsOpen(false)}
        appElement={document.getElementById("bfc-single-page-app")}
        className="tooltip-container"
        overlayClassName="tooltip-overlay"
      >
        <CloseButton
          onClick={() => isModalIsOpen(false)}
          data-id="Tooltip__Modal__CloseButton"
        >
          <Glyphicon name="circle-remove" />
        </CloseButton>
        {content}
      </ReactModal>
    </>
  );
};

Tooltip.propTypes = {
  content: PropTypes.node.isRequired,
  dataId: PropTypes.string,
};
